import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles = [], fallback = "/admin" }) {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center text-gray-500">
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to={fallback} replace />;
  }

  if (roles.length > 0 && !roles.includes(profile?.role)) {
    if (profile?.role === "driver") {
      return <Navigate to="/chauffeur/dashboard" replace />;
    }
    return <Navigate to={fallback} replace />;
  }

  return children;
}
